module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.6@readable-stream/duplex-browser.js
// module id = CpsB
// module chunks = 0